/****PLEASE DON'T MAKE CHANGES IN THIS FILE IT'S AFFECT THE CODE IF YOU NEED ANY HELP PLEASE CONTACT TO FLITS TEAM support@getflits.com ****/
(function (Flits) {
  /* To load js in all pages */
  if (
    Flits.Metafields.IS_SOCIAL_LOGIN_PAID &&
    Flits.Metafields.IS_SOCIAL_LOGIN_ENABLE
  ) {
    if (window.flitsObjects.allCssJs.socialLoginJs) {
      Flits.LoadStyleScript(
        "socialLoginJs",
        window.flitsObjects.allCssJs.socialLoginJs.url
      );
    }
  }
  Flits(document).on("Flits:Loaded", function (event) {
    Flits('[href="/tools/customr/edit-account"]')
      .attr("href", "/account#profile")
      .addClass("flits-custom-tab-add");
  });

  Flits(document).on("Flits:wishlistButton:Loaded", function (event) {
    if (Flits.request.page_type == "product") {
      setTimeout(function () {
        let cloneSource = Flits(
          ".product-add-to-cart-container .filts-wishlist-product-style"
        );
        let appendSource = Flits(".flits-wishlist-product-page-clone");
        if (cloneSource && appendSource) {
          let wconeHtml = cloneSource.clone();
          appendSource.html(wconeHtml);
        }
      }, 3000);
    }
  });
  function cloneWishlistBtnUpdate() {
    let el = Flits(".flits-wishlist-product-page-clone .flits-wls-button");
    let is_add;
    let count = 0;
    let wsl_product_count = 0;
    Flits(el).hasClass("flits-wls-inactive")
      ? (is_add = true)
      : (is_add = false);
    if (Flits(el).parent().find(".flits-wls-count-btn")) {
      count = Flits(el).parent().find(".flits-wls-count-btn").text();
    }
    if (is_add) {
      wsl_product_count = parseInt(count) + 1;
      Flits(el).animateWishlistButton(
        wsl_product_count,
        Flits.t(
          "Flits.locals.wishlisted_product_page.remove_from_wishlist_button",
          "Added to Wishlist"
        )
      );
    } else {
      wsl_product_count = parseInt(count) - 1;
      Flits(el).animateWishlistButton(
        wsl_product_count,
        Flits.t(
          "Flits.locals.wishlisted_product_page.add_to_wishlist_button",
          "Add to Wishlist"
        )
      );
    }
  }
  Flits(document).on(
    "click",
    ".flits-wishlist-product-page-clone .flits-wls-button",
    function (event) {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      Flits(".product-add-to-cart-container .flits-wls-button").trigger(
        "click"
      );
      // setTimeout(function(){
      //   cloneWishlistBtnUpdate();
      // }, 300);
    }
  );
  Flits(document).on(
    "click",
    ".product-add-to-cart-container .flits-wls-button",
    function (event) {
      setTimeout(function () {
        cloneWishlistBtnUpdate();
      }, 300);
    }
  );

  //  Flits(document).on("Flits:AccountPage:Loaded",function(event){
  //    var data = event.detail.settings;
  //    data.active_tab = window.flits_current_page;
  // })

  Flits("a[href$='/account/logout']").attr("data-no-instant", "");
  window.onload = function (event) {
    var all_logout = document.querySelectorAll("a[href$='/account/logout']"); // Change selector as per you reqirement.
    for (var i = 0; i < all_logout.length; i++) {
      var al = all_logout[i];
      al.setAttribute("data-no-instant", "");
    }
  };
  Flits(document).on("click", ".flits-reorder-btn2", function () {
    let el = Flits(this);
    let quantity = parseInt(
      Flits(el).parent().find('input[name="product_quantity_input"]').val()
    );
    let maxLimit = parseInt(
      Flits(el)
        .parent()
        .find('input[name="product_quantity_input"]')
        .attr("max")
    );
    let id = Flits(el).attr("data-flits-variant-id");
    let interval = 0;
    if (cartOrder[id]) {
      if (quantity + parseInt(cartOrder[id].cart_quantity) > maxLimit) {
        quantity = maxLimit - parseInt(cartOrder[id].cart_quantity);
        quantity == 0 ? (quantity = maxLimit) : quantity;
        interval = 3000;
        flitsSnackbar.show({
          text: Flits.t(
            "Flits.locals.general.cart_updated",
            "Some items are no longer available. Your cart has been updated."
          ),
          pos: "bottom-center",
          showAction: false,
          customClass: "flits-alert-default",
        });
      }
    }
    let data = "id=" + id + "&quantity=" + quantity;
    setTimeout(function () {
      Flits.addToCart(data);
    }, interval);
  });
  if (Flits.request.page_type == "customers/account") {
    Flits(document).on("click", ".flits-custom-tab-add", function (e) {
      var elem_href = Flits.parseURL(Flits(this).attr("href")).hash;
      Flits.navigationFunc(elem_href);
    });
  }

  function diff_minutes(dt1, dt2) {
    if (dt1 == undefined || dt2 == undefined) {
      return 0;
    } else {
      var diff = (dt2.getTime() - dt1.getTime()) / 1000;
      diff /= 60;
      return Math.abs(Math.round(diff));
    }
  }
  function addToCartTopOrder(params) {
    flitsSnackbar.show({
      text: Flits.t(
        "Flits.locals.cart_page.adding_items_to_cart",
        "Adding items to cart..."
      ),
      pos: "bottom-center",
      showAction: false,
      customClass: "flits-alert-default",
      duration: false,
    });
    Flits.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: params,
      dataType: "json",
    })
      .done(function (resp) {
        // Flits.flitsSnackbarHide();
        // location.href = "/cart";
        flitsSnackbar.show({
          text: Flits.t(
            "Flits.locals.cart_page.added_to_cart",
            "Product successfully added to cart!"
          ),
          pos: "bottom-center",
          showAction: false,
          customClass: "flits-alert-success",
        });
        setTimeout(function () {
          Flits.flitsSnackbarHide();
        }, 3000);
      })
      .fail(function (resp) {
        flitsSnackbar.show({
          text: resp.responseJSON.description,
          pos: "bottom-center",
          showAction: false,
          customClass: "flits-alert-error",
        });
      })
      .always(function () {});
  }
  Flits(document).ready(function () {
    Flits("#loader").show(); // Show the loader
  });
  window.onload = function (params) {
    if (
      Flits.customer_id !== -1 &&
      Flits.customer_id !== undefined &&
      Flits.customer_id !== null &&
      flitsObjects.storeData.request.page_type === "index"
    ) {
      let dt1 = new Date(Flits.getLocalStorage("last_top_order_call"));
      let dt2 = new Date();

      Flits.ajax({
        type: "GET",
        url:
          Flits.base_url +
          "/" +
          Flits.customer_id +
          "/top_product_from_all_order",
        contentType: "application/x-www-form-urlencoded",
        data: { customer_hash: Flits.customerHash, token: Flits.token },
      })
        .done(function (resp) {
          if (resp.orders_count > 0) {
            let products = resp.products.slice(0, 12);
            let productData = resp.products_data;
            Flits.setLocalStorage("last_top_order_call", new Date());
            //let clone = Flits(".flits-top-order-custom-skeleton").clone().removeClass("flits-top-order-custom-skeleton");
            // document.querySelector('.no-orders-message').style.display = resp.orders_count > 0 ? 'none' : 'block';
            // document.querySelector('.no-orders-message').style.opacity = '1';
            products.forEach(function (item, index) {
              let data = productData[item.id];
              let variant = data.variants.find(
                (variant) => variant.id === item.variant_id
              );

              // Create a new clone for each product
              let clone = Flits(".flits-top-order-custom-skeleton")
                .clone()
                .removeClass("flits-top-order-custom-skeleton");

              Flits(clone)
                .find(".flits-product-image-thumbnail img")
                .attr("src", data?.image?.src);
              Flits(clone)
                .find(".flits_product_name_wrapper")
                .attr("href", `/products/${data?.handle}`);
              Flits(clone).find(".flits-product-name").text(item?.title);
              let priceTopOrder = Flits.formatMoney(
                variant?.price,
                Flits.money_format
              );
              Flits(clone).find(".flits-product-price").text(priceTopOrder);
              Flits(clone)
                .find(".flits-variant-select option")
                .attr("data-flits-variant-price", priceTopOrder);
              Flits(clone)
                .find(".flits-variant-select option")
                .attr("value", variant.id);
              Flits(clone)
                .find(".flits-variant-select option")
                .text(variant.title);
              Flits(".flits-index-page-top-order-main").append(clone);
              Flits(clone).css("display", "");
            });
          } else {
            // document.querySelector('.no-orders-message').style.display = resp.orders_count > 0 ? 'none' : 'block';
            document.querySelector(".no-orders-message").style.opacity = "1";
          }
        })
        .fail(function (resp) {
          flitsSnackbar.show({
            text: resp.statusText,
            pos: "bottom-center",
            showAction: false,
            customClass: "flits-alert-danger",
          });
        })
        .always(function () {
          Flits("#loader").hide();
        });
    }
  };
  Flits(document).on("click", ".flits-custom-add-to-cart", function () {
    let el = Flits(this);
    let quantity = parseInt(
      Flits(el)
        .parents(".flits-product-card")
        .find('input[name="product_quantity_input"]')
        .val()
    );
    let maxLimit = parseInt(
      Flits(el)
        .parents(".flits-product-card")
        .find('input[name="product_quantity_input"]')
        .attr("max")
    );
    let id = Flits(el)
      .parents(".flits-product-card")
      .find(".flits-variant-select")
      .val();
    let interval = 0;
    if (cartOrder[id]) {
      if (quantity + parseInt(cartOrder[id].cart_quantity) > maxLimit) {
        quantity = maxLimit - parseInt(cartOrder[id].cart_quantity);
        quantity == 0 ? (quantity = maxLimit) : quantity;
        interval = 3000;
        flitsSnackbar.show({
          text: Flits.t(
            "Flits.locals.general.cart_updated",
            "Some items are no longer available. Your cart has been updated."
          ),
          pos: "bottom-center",
          showAction: false,
          customClass: "flits-alert-default",
        });
      }
    }
    let data = "id=" + id + "&quantity=" + quantity;
    setTimeout(function () {
      addToCartTopOrder(data);
    }, interval);
  });
  
  // Flits(document).on("Flits:topOrderTemplate:Loaded", function (event) {
  //   setTimeout(function () {
  //     var klaviyoScript = document.createElement("script");
  //     klaviyoScript.src = "https://a.klaviyo.com/media/js/onsite/onsite.js";
  //     klaviyoScript.onload = function () {
  //       var klaviyo = window.klaviyo || [];
  //       klaviyo.init({
  //         account: "QaUcVC",
  //         platform: "shopify",
  //       });
  //       klaviyo.enable("backinstock", {
  //         trigger: {
  //           product_page_text: "Notify Me When Available",
  //           product_page_class: "button",
  //           product_page_text_align: "center",
  //           product_page_margin: "0px",
  //           replace_anchor: false,
  //         },
  //         modal: {
  //           headline: "{product_name}",
  //           body_content:
  //             "Register to receive a notification when this item comes back in stock.",
  //           email_field_label: "Email",
  //           button_label: "Notify me when available",
  //           subscription_success_label:
  //             "You're in! We'll let you know when it's back.",
  //           footer_content: "",
  //           additional_styles:
  //             "@import url('https://fonts.googleapis.com/css?family=Helvetica+Neue');",
  //           drop_background_color: "#000",
  //           background_color: "#fff",
  //           text_color: "#222",
  //           button_text_color: "#fff",
  //           button_background_color: "#439fdb",
  //           close_button_color: "#ccc",
  //           error_background_color: "#fcd6d7",
  //           error_text_color: "#C72E2F",
  //           success_background_color: "#d3efcd",
  //           success_text_color: "#1B9500",
  //         },
  //       });
  //     };
  //     document.head.appendChild(klaviyoScript);
  //   }, 6000); // Delay in milliseconds
  // });
  // Support : Rocket Start Code
  function showEmailError(message, color = "red") {
    Flits("#email-error").text(message).css("color", color).show();
  }
  function clearEmailError() {
    Flits("#email-error").text("").hide();
  }
  function isValidEmail(email) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  }
  const NotifyKlaviyoFlits = function (e) {
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    function decodeHtml(html) {
      var txt = document.createElement("textarea");
      txt.innerHTML = html;
      return txt.value;
    }
    const variantID = e.target.getAttribute("data-flits-variant-id");
    const productTitle = decodeHtml(
      decodeURIComponent(
        atob(e.target.getAttribute("data-flits-product-title")).replace(
          /\+/g,
          " "
        )
      )
    );

    if (productTitle !== "") {
      Flits(".flits-notify-klaviyo-modal").find(".modal-title")[0].textContent =
        productTitle;
    }
    Flits(".flits-notify-klaviyo-modal").fadeIn();
    Flits(".flits-notify-klaviyo-modal")
      .find("#notify-submit-btn")
      .attr("data-flits-variant-id", variantID);
    Flits(".flits-notify-klaviyo-modal .close-button").on("click", function () {
      Flits(".flits-notify-klaviyo-modal").fadeOut();
      clearEmailError();
    });

    // Handle Notify button click
  };
  const handleNotifyMeFormSubmit = (email, variantID) => {
    const payload = {
      data: {
        type: "back-in-stock-subscription",
        attributes: {
          profile: {
            data: {
              type: "profile",
              attributes: {
                email: email,
              },
            },
          },
          channels: ["EMAIL"],
        },
        relationships: {
          variant: {
            data: {
              type: "catalog-variant",
              id: `$shopify:::$default:::${variantID}`,
            },
          },
        },
      },
    };

    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        revision: "2024-06-15",
      },
      body: JSON.stringify(payload),
    };
    Flits.ajax({
      url: "https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=QaUcVC",
      method: requestOptions.method || "POST", // default to POST if not specified
      headers: requestOptions.headers || {},
      body: requestOptions.body, // Not directly used in jQuery
      contentType: "application/json",
      data: requestOptions.body, // this should be a JSON string if you're sending JSON
      success: function (response, textStatus, xhr) {
        if (xhr.status === 202) {
          showEmailError(
            "You're in! We'll let you know when it's back.",
            "#2E7D32"
          );
          console.log(response);
          $("#notify-email").val("");
        } else {
          $("#notify-email").val("");
          showEmailError(
            "Something went wrong. Please try again later.",
            "red"
          );
        }
      },
      error: function (xhr, textStatus, errorThrown) {
        if (xhr.responseJSON.errors.length > 0) {
          showEmailError(xhr.responseJSON.errors[0].title, "red");
        } else {
          showEmailError("Network error. Please try again later.", "red");
        }
        $("#notify-email").val("");
      },
    });
  };
  Flits(document).on("click", "#notify-submit-btn", function (events) {
    events.preventDefault();
    events.stopPropagation();
    events.stopImmediatePropagation();
    const email = Flits("#notify-email").val().trim();
    clearEmailError();
    if (email === "") {
      showEmailError("Please enter your email.");
    } else if (!isValidEmail(email)) {
      showEmailError("Please enter a valid email address.");
    } else {
      handleNotifyMeFormSubmit(
        email,
        events.target.getAttribute("data-flits-variant-id")
      );
    }
  });
  Flits(document).on("click", ".flits-klaviyo-notify-btn", NotifyKlaviyoFlits);
  // Support : Rocket End Code
  //added appstle code from here
  Flits(document).on('Flits:Navigation:Loaded', function(event) {
	var settings = event.detail.settings;
	var obj = {
        // title: 'Appstle Membership',
		title: 'WJW Membership',
		// url: '#appstleMembership',
		url: '/apps/memberships',
		target: 1,
		badge: null,
		icon: `<svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 19 19"><path d="M9.92,19.5a.4.4,0,0,1-.28-.12A.4.4,0,0,1,9.53,19l.56-2.8a.39.39,0,0,1,.11-.2l6.16-6.16a1.19,1.19,0,0,1,1.68,0L19.15,11a1.19,1.19,0,0,1,0,1.68L13,18.82a.39.39,0,0,1-.2.11l-2.8.56H9.92m.92-3-.42,2.1,2.1-.42,6.07-6.07a.4.4,0,0,0,0-.56l-1.12-1.12a.4.4,0,0,0-.56,0ZM12,2.87H10.79v-.4a.4.4,0,0,0-.4-.4H9.17a2,2,0,0,0-3.88,0H4.06a.4.4,0,0,0-.4.4v.4H2.48a2,2,0,0,0-2,2V15.15a2,2,0,0,0,2,2H8a.4.4,0,0,0,0-.79H2.48a1.19,1.19,0,0,1-1.19-1.19V4.85A1.19,1.19,0,0,1,2.48,3.67H3.67v.4A1.19,1.19,0,0,0,4.85,5.25H9.6a1.19,1.19,0,0,0,1.19-1.19v-.4H12a1.19,1.19,0,0,1,1.19,1.19V9.6a.4.4,0,1,0,.79,0V4.85a2,2,0,0,0-2-2M10,4.06a.4.4,0,0,1-.4.4H4.85a.4.4,0,0,1-.4-.4V2.87H5.65a.4.4,0,0,0,.4-.4,1.19,1.19,0,0,1,2.38,0,.4.4,0,0,0,.4.4H10Zm1.19,3.56H3.27a.4.4,0,0,1,0-.79h7.92a.4.4,0,0,1,0,.79m0,2.38H3.27a.4.4,0,0,1,0-.79h7.92a.4.4,0,0,1,0,.79m0,2.38H3.27a.4.4,0,0,1,0-.79h7.92a.4.4,0,0,1,0,.79" transform="translate(-0.5 -0.5)" /></svg>`,
		isShow: 1,
		loader: null,
		body_html: `<div id="AppstleMembershipCustomerPortal" class="appstle_membership_cp"></div>`
	};
	settings.navs.splice(6, 0, obj);
	setTimeout(function(){
      
    if(window.appstleMembershipCustomerPortalInit){          
      
      if(window.innerWidth >= 767){      
      window.appstleMembershipCustomerPortalInit('.flits-desktop-view #AppstleMembershipCustomerPortal');
      }else{        
      window.appstleMembershipCustomerPortalInit('.flits-mobile-view #AppstleMembershipCustomerPortal');
      }
    }
  }, 5000)
});

//till here

})(Flits);


// support we have added below custom code..
document.addEventListener("DOMContentLoaded", () => {
  const MAX_ATTEMPTS = 5;
  const RETRY_DELAY = 1000;
  let attempts = 0;

  function checkForAppstleElement() {
    const AppstleElement = document.querySelector("#flits_tab_appstleMembership");
    
    if (AppstleElement) {
      // console.log("Element found!", AppstleElement);
      AppstleElement.querySelector(".flits-account-box-header").style.display="none";
      return;
    }

    attempts++;
    console.log(`Attempt ${attempts}: Element not found`);

    if (attempts < MAX_ATTEMPTS) {
      setTimeout(checkForAppstleElement, RETRY_DELAY);
    } else {
      console.log(`Element not found after ${MAX_ATTEMPTS} attempts`);
    }
  }
  checkForAppstleElement();
});
// Support Code Ends here..
